import Vue from 'vue';
import utils from '@/utils';

Vue.filter('round', utils.number.round);